// src/pages/GrindResults.js

import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { grinders } from "../grinders";

function GrindResults() {
  const [results, setResults] = useState([]);
  const [selectedBean, setSelectedBean] = useState("");
  const [allBeans, setAllBeans] = useState([]);
  const [selectedGrinder, setSelectedGrinder] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "grindSettings"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setResults(data);

      const beans = [...new Set(data.map(r => r.coffee).filter(Boolean).sort())];
      setAllBeans(beans);
    };

    fetchData();
  }, []);

  const hasFilters = selectedBean || selectedGrinder || selectedMethod;

  const filteredResults = results.filter((entry) => {
    return (
      (selectedBean === "" || entry.coffee === selectedBean) &&
      (selectedGrinder === "" || entry.grinder === selectedGrinder) &&
      (selectedMethod === "" || entry.brewMethod === selectedMethod)
    );
  });

  const uniqueGrinders = grinders.sort();
  const uniqueMethods = [...new Set(results.map(r => r.brewMethod).filter(Boolean).sort())];

  return (
    <div className="min-h-screen bg-[#f3e3d0] p-6">
      <h1 className="text-3xl font-bold text-[#3a241d] mb-6 text-center">Grind Results</h1>

      {/* Filter Controls */}
      <div className="bg-white p-4 rounded-lg shadow max-w-4xl mx-auto mb-6 flex flex-col sm:flex-row gap-4">
        <select
          className="border p-2 rounded w-full"
          value={selectedBean}
          onChange={(e) => setSelectedBean(e.target.value)}
        >
          <option value="">All Coffee Beans</option>
          {allBeans.map((bean, i) => (
            <option key={i} value={bean}>{bean}</option>
          ))}
        </select>

        <select
          className="border p-2 rounded w-full"
          value={selectedGrinder}
          onChange={(e) => setSelectedGrinder(e.target.value)}
        >
          <option value="">All Grinders</option>
          {uniqueGrinders.map((g, idx) => (
            <option key={idx} value={g}>{g}</option>
          ))}
        </select>

        <select
          className="border p-2 rounded w-full"
          value={selectedMethod}
          onChange={(e) => setSelectedMethod(e.target.value)}
        >
          <option value="">All Brew Methods</option>
          {uniqueMethods.map((m, idx) => (
            <option key={idx} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {/* Results List */}
      <div className="grid gap-6 max-w-4xl mx-auto">
        {!hasFilters ? (
          <p className="text-center text-[#5c4432] italic">
            Use the search or filters above to view grind settings.
          </p>
        ) : filteredResults.length === 0 ? (
          <p className="text-center text-[#5c4432]">No grind data matches your filters or search.</p>
        ) : (
          filteredResults.map((entry) => (
            <div
              key={entry.id}
              className="bg-white rounded-xl shadow-md p-6 border border-[#d2bba1]"
            >
              <div className="flex items-center justify-between mb-3">
                <h2 className="text-xl font-semibold text-[#3a241d]">{entry.coffee}</h2>
                <p className="text-5xl font-bold text-[#3a241d]">{entry.grindSetting}</p>
              </div>
              <div className="text-sm text-[#5c4432] space-y-1">
                <p><strong>Grinder:</strong> {entry.grinder}</p>
                <p><strong>Brew Method:</strong> {entry.brewMethod}</p>
                <p><strong>Roast Level:</strong> {entry.grindType}</p>
                {entry.notes && <p className="italic">{entry.notes}</p>}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GrindResults;
